import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage, successMessage } from "../../../utlis/common";
import { SOME_WENT_WRONG } from "../../../utlis/messages";
import { addNewProperty, removeProperty, updateProperty } from "./propertySlice";


export const CreateProrperty = createAsyncThunk(
  "CreateProperty",
  async ({ values, resetForm, loading }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('', dispatch).post(`property`, values);
      resetForm();
      if (!loading) {
        successMessage(response.data.message.details);
      }
      dispatch(addNewProperty(response?.data));
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);


export const UpdateProperty = createAsyncThunk(
  "UpdateProperty",
  async ({id, values, navigate, resetForm, loading }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      console.log(values, loading)
      const response = await customAxios('', dispatch).put(`property/${id}`, values);
      resetForm();
      if (!loading) {
        successMessage(response.data.message.details);
      }
      dispatch(updateProperty(response.data));
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);


export const GetProperties = createAsyncThunk(
  "Properties",
  async ({page,limit,search = ""}:any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`property?page=${page}&limit=${limit}&search=${search}`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const DeleteProperty = createAsyncThunk(
  "DeleteProperty",
  async (id: string, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).delete(`property/${id}`);
      successMessage(response.data.message['details'])
      dispatch(removeProperty(id));
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);
